(() => {
  const article = document.querySelector('.rb-guide[data-rb-guide-v2]');
  if (!article) return;

  const body = article.querySelector('.rb-guide__body');
  if (!body) return;

  const comparisonTable = body.querySelector('table');
  if (article.dataset.rbGuideKind === 'comparison' && comparisonTable) {
    const labels = [...comparisonTable.querySelectorAll('thead th')].map((cell) => cell.textContent.trim());
    comparisonTable.querySelectorAll('tbody tr').forEach((row) => {
      [...row.querySelectorAll('td')].forEach((cell, index) => {
        if (labels[index] && !cell.hasAttribute('data-label')) {
          cell.setAttribute('data-label', labels[index]);
        }
      });
    });
  }

  const headings = [...body.querySelectorAll('h2')];
  const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
  headings.forEach((heading, index) => {
    if (heading.id) return;
    const base = heading.textContent
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || `section-${index + 1}`;
    let candidate = base;
    let suffix = 2;
    while (usedIds.has(candidate)) {
      candidate = `${base}-${suffix}`;
      suffix += 1;
    }
    heading.id = candidate;
    usedIds.add(candidate);
  });

  const tocLists = [...article.querySelectorAll('[data-rb-guide-toc-list]')];
  const tocLinks = [];
  tocLists.forEach((list) => {
    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      tocLinks.push(link);
    });
  });

  if (headings.length) {
    article.querySelectorAll('.rb-guide-toc, .rb-guide-toc-mobile').forEach((toc) => {
      toc.hidden = false;
    });

    const setCurrent = (id) => {
      tocLinks.forEach((link) => {
        if (link.hash === `#${id}`) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    let tocTicking = false;
    const updateToc = () => {
      const threshold = Math.max(96, window.innerHeight * 0.18);
      let active = headings[0];
      headings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= threshold) active = heading;
      });
      setCurrent(active.id);
      tocTicking = false;
    };
    const requestToc = () => {
      if (tocTicking) return;
      tocTicking = true;
      window.requestAnimationFrame(updateToc);
    };

    tocLinks.forEach((link) => {
      link.addEventListener('click', () => setCurrent(link.hash.slice(1)));
    });
    requestToc();
    window.addEventListener('scroll', requestToc, { passive: true });
    window.addEventListener('resize', requestToc);
    window.addEventListener('hashchange', () => {
      const id = window.location.hash.slice(1);
      if (headings.some((heading) => heading.id === id)) setCurrent(id);
    });
  }

  const progress = article.querySelector('.rb-guide-progress span');
  if (progress) {
    let progressTicking = false;
    const updateProgress = () => {
      const start = article.getBoundingClientRect().top + window.scrollY;
      const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
      const ratio = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
      progress.style.transform = `scaleX(${ratio})`;
      progressTicking = false;
    };
    const requestProgress = () => {
      if (progressTicking) return;
      progressTicking = true;
      window.requestAnimationFrame(updateProgress);
    };
    updateProgress();
    window.addEventListener('scroll', requestProgress, { passive: true });
    window.addEventListener('resize', requestProgress);
  }

  const helper = article.querySelector('.rb-guide-helper');
  if (helper) {
    const outcomes = {
      movement: {
        title: 'Physical AI golf caddy',
        copy: 'Start here when reducing continuous bag management is the job. Confirm follow, stopping, recovery and takeover controls.',
      },
      control: {
        title: 'Remote electric trolley',
        copy: 'Start here when you want powered transport and prefer to decide exactly where the trolley goes. Compare braking, stability, remote handling and backup control.',
      },
      advice: {
        title: 'AI caddie app or watch feature',
        copy: 'Start here when shot planning is the problem. It can add information or recommendations, but it does not move the bag.',
      },
    };
    const buttons = [...helper.querySelectorAll('button[data-rb-category]')];
    const title = helper.querySelector('.rb-guide-helper__result-title');
    const copy = helper.querySelector('.rb-guide-helper__result-copy');

    buttons.forEach((button) => {
      button.disabled = false;
      button.addEventListener('click', () => {
        const outcome = outcomes[button.dataset.rbCategory];
        if (!outcome || !title || !copy) return;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        title.textContent = outcome.title;
        copy.textContent = outcome.copy;
      });
    });

    const tableWrapper = body.querySelector('.rb-guide__table-scroll');
    if (tableWrapper) tableWrapper.insertAdjacentElement('afterend', helper);
  }

  const checks = article.querySelector('.rb-guide-checks');
  const firstHeading = body.querySelector('h2');
  if (checks && firstHeading) body.insertBefore(checks, firstHeading);
})();
